<template>
  <slot v-bind="{ href: AlifJumaUrl }" />
</template>

<script setup>
  import { inject } from 'vue';

  const AlifJumaUrl = inject('alif_juma_url');
</script>
